import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './myaccount.css';
import $ from 'jquery';
//V2
import { getDistrictQuotesV2, updateQuoteBudgetYear } from '../../api/districtquoteapi.js';//getDistrictQuotes
import { useNavigate } from 'react-router-dom';
import { checkForDistrictId } from '../../helpers/checkForDistrictId';
import Banner from '../../components/common/ShowBannerDetails';
import { formatDateTimeForUserTimeZone } from '../../helpers/DateTimeFormatter';
import { updateTitle } from '../../helpers/titleHelper';
import { getAllV2 as getAllManufacturersV2 } from '../../api/manufacturersapi';
import { getAllSchools } from '../../api/schoolsApi';
import { getAllDealers, getDealerDetails } from '../../api/dealersApi';
import { formatUSD } from '../../helpers/formatterHelper';
import DealerDetails from '../../components/common/DealerDetails';
import { setSelectedSchoolName } from '../../store/school-reducer';
import { getAllBudgetYears } from '../../api/budgetYearsApi';
import PageLoadingSpinner from '../../components/FullPageLoader';
import { checkLogin } from '../../api/checkuserapi';
import { setQuoteHighlighterId } from '../../store/myproject-reducer';

export default function MyAccount() {
    updateTitle('My Quotes');
    const navigate = useNavigate();
    const quoteHighlighterId = useSelector((state) => state.myProject.quoteHighlighterId);
    const dispatch = useDispatch();

    $(document).ready(function () {
        $(".admin-table").parents('div.admin-table-wrap').addClass("admin-table-data");
    });
    const [quotes, setQuotes] = useState({ quotesTotal: 0, results: [] });
    const [filter, setFilter] = useState({ start: 1, length: 999, search: '', status: -1, sort: -1, user: true, isMyAccountPage: true, searchQuoteNumber: '', searchBudgetYear: 0, searchManufactureId: 0, searchSchoolId: 0, searchDealerId: null });
    const districtId = localStorage.getItem('districtId');
    const [expandedQuoteId, setExpandedQuoteId] = useState(null);
    const [manufacturers, setManufacturers] = useState([]);
    const [selectedManufacturer, setSelectedManufacturer] = useState("");
    const [schools, setSchools] = useState([]);
    const [budgetYearsList, setBudgetYearsList] = useState([]);
    const [selectedSchool, setSelectedSchool] = useState("");
    const [dealerList, setDealerList] = useState([]);
    const [selectedDealer, setSelectedDealer] = useState("");
    const [searchQuote, setSearchQuote] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const modalRef = useRef(null);
    const tableStickyRef = useRef(null);
    const [isScrolled, setIsScrolled] = useState(false);
    const [selectedBudgetYear, setSelectedBudgetYear] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [isEndUser, setIsEndUser] = useState(false);
    const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

    const [dealersDetails, setDealersDetails] = useState([]);
    const [popupContext, setPopupContext] = useState({
        show: false,
        type: null,
        rowIndex: null,
        subRowIndex: null
    });
    const [selectedManufacturerRowIndex, setSelectedManufacturerRowIndex] = useState(null);
    const [selectedStatusRowIndex, setSelectedStatusRowIndex] = useState(null);

    useEffect(() => {
        if (!isLoading && quoteHighlighterId > 0 && quotes?.results?.length > 0) {
            const scrollTimeout = setTimeout(() => {
                const highlightedRow = document.querySelector(`tr.highlight`);
                if (highlightedRow) {
                    highlightedRow.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            }, 500);

            return () => clearTimeout(scrollTimeout);
        }
    }, [isLoading, quoteHighlighterId, quotes?.results]);

    useEffect(() => {
        if (quoteHighlighterId > 0) {
            setExpandedQuoteId(parseInt(quoteHighlighterId));
            const isValidFilter =
                filter.searchManufactureId != 0 ||
                filter.searchSchoolId != 0 ||
                filter.searchDealerId != null ||
                filter.searchBudgetYear != 0 ||
                filter.searchQuoteNumber != '' ||
                filter.status != -1;


            if (isValidFilter) {
                setFilter({
                    ...filter,
                    searchManufactureId: 0,
                    searchSchoolId: 0,
                    searchDealerId: null,
                    searchQuoteNumber: '',
                    searchBudgetYear: 0,
                    status: -1
                });
                setSelectedSchool("");
                setSelectedDealer("");
                setSearchQuote("");
                setSelectedManufacturer("");
                setSelectedBudgetYear(0);
            }
        }
    }, [quoteHighlighterId]);

    useEffect(() => {
        checkLogin().then((response) => {
            if (response.data.success == true) {
                const loginUser = response.data.data;
                var userRole = loginUser && loginUser.userRoles.find(x => x.siteRole.name === "user");
                if (userRole && loginUser.userRoles.length === 1) {
                    setIsEndUser(true);
                }
            } else {
                setIsEndUser(false);
            }
        });
    }, []);

    useEffect(() => {
        checkForDistrictId(navigate);

        //V2   
        setIsLoading(true);
        getDistrictQuotesV2(districtId, filter)
            .then((response) => {
                setQuotes(response.data.data);
                setIsLoading(false);
            });

    }, [districtId, filter]);

    useEffect(() => {
        getAllManufacturersV2(districtId)
            .then((response) => {
                setManufacturers(response.data.data); // assuming response.data.data is an array of manufacturers
            })
            .catch((error) => {
                console.error("Error fetching manufacturers:", error);
            });

        getAllBudgetYears()
            .then((response) => {
                if (response.data.success) {
                    setBudgetYearsList(response.data.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching manufacturers:", error);
            });

    }, []);

    useEffect(() => {
        const fetchSchools = async () => {
            try {
                const response = await getAllSchools(districtId);
                if (response.data.success) {
                    setSchools(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching schools:', error);
            }
        };

        const fetchDealers = async () => {
            try {
                const response = await getAllDealers(districtId);
                if (response.data.success) {
                    setDealerList(response.data.data);
                }
            } catch (error) {
                console.error('Error fetching schools:', error);
            }
        };

        fetchSchools();
        fetchDealers();
    }, [districtId]);

    const removeHighlighter = () => {
        if (quoteHighlighterId > 0) {
            dispatch(setQuoteHighlighterId(0));
        }
    }

    const handleManufacturerChange = (e) => {
        var value = e.target.value;
        setSelectedManufacturer(value);
        removeHighlighter();
        const newSort = filter.sort === -1 ? 1 : filter.sort;
        setFilter({ ...filter, searchManufactureId: value, sort: newSort });
    };

    const handleSchoolChange = (e) => {
        var value = e.target.value;
        setSelectedSchool(value);
        const selected = schools.find(x => x.baseId === value);
        const schoolName = selected ? selected.name : '';
        setSelectedSchoolName(schoolName);
        removeHighlighter();
        const newSort = filter.sort === -1 ? 1 : filter.sort;
        setFilter({ ...filter, searchSchoolId: value, sort: newSort });
    };

    const handleDealerChange = (e) => {
        var value = e.target.value;
        if (value == '') {
            setSelectedDealer("");
            value = null;
        }
        else {
            setSelectedDealer(value);
        }
        removeHighlighter();
        const newSort = filter.sort === -1 ? 1 : filter.sort;
        setFilter({ ...filter, searchDealerId: value, sort: newSort });
    };

    const handleChangeStatus = (e) => {
        removeHighlighter();
        var value = parseInt(e.target.value);
        const newSort = filter.sort === -1 ? 1 : filter.sort;
        setFilter({ ...filter, status: value, sort: newSort });
    };


    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchQuote(value);
        if (value === "") {
            handleQuoteNumberChange(e);
        }
    };


    const handleQuoteNumberChange = (e) => {
        const value = e.target.value;
        removeHighlighter();
        if (value.length > 2) {
            const newSort = filter.sort === -1 ? 1 : filter.sort;
            setFilter((prev) => ({
                ...prev,
                searchQuoteNumber: value,
                sort: newSort
            }));
        } else {
            setFilter((prev) => ({
                ...prev,
                searchQuoteNumber: '',
            }));
        }
    };

    const checkSameDealers = (subQuotes) => {
        if (!subQuotes || subQuotes.length === 0) return true;

        const firstDealerId = subQuotes[0]?.dealerId;

        return subQuotes.every(subQuote =>
            subQuote?.dealerId === firstDealerId
        );
    }

    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            setIsModalOpen(false);
        }
    };

    useEffect(() => {
        if (isModalOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isModalOpen]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollLeft = tableStickyRef.current.scrollLeft;
            if (scrollLeft > 0) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        const tableElement = tableStickyRef.current;
        if (tableElement) {
            tableElement.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (tableElement) {
                tableElement.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    const clearAllFilters = () => {
        setSelectedManufacturer("0");
        setSelectedSchool("0");
        setSelectedDealer("");
        setSearchQuote("");
        setFilter({
            ...filter,
            searchManufactureId: 0,
            searchSchoolId: 0,
            searchDealerId: null,
            searchQuoteNumber: '',
            searchBudgetYear: 0
        });
    };

    const applyCurrentFilters = () => {
        const newSort = filter.sort === -1 ? 1 : filter.sort;
        setFilter(prev => ({
            ...prev,
            searchManufactureId: parseInt(selectedManufacturer) || 0,
            searchSchoolId: parseInt(selectedSchool) || 0,
            searchDealerId: selectedDealer ? selectedDealer : null,
            searchQuoteNumber: searchQuote,
            searchBudgetYear: parseInt(selectedBudgetYear) || 0,
            sort: newSort
        }));
    };

    const handleClearFilters = () => {
        clearAllFilters();
        setIsModalOpen(false);
    };

    const handleApplyFilters = () => {
        applyCurrentFilters();
        setIsModalOpen(false);
    };
    const fetchDealersDetails = async (dealerIds, rowIndex, subRowIndex = null) => {
        try {
            if (!dealerIds || dealerIds.length === 0) return;

            const dealerIdsString = dealerIds.join(',');
            const response = await getDealerDetails(dealerIdsString);

            if (response.data.success) {
                setDealersDetails(response.data.data);
                setPopupContext({
                    show: true,
                    type: subRowIndex !== null ? 'sub' : 'main',
                    rowIndex,
                    subRowIndex
                });
            }
        } catch (err) {
            console.error('Failed to fetch dealer details:', err);
            setPopupContext({
                show: false,
                type: null,
                rowIndex: null,
                subRowIndex: null
            });
        }
    };
    const closePopup = () => {
        setPopupContext({
            show: false,
            type: null,
            rowIndex: null,
            subRowIndex: null
        });
    };
    const getDealerDisplayText = (subQuotes) => {
        if (!subQuotes || !subQuotes.length) return "";

        const dealerNames = subQuotes.map(sq => sq.dealerName).filter(name => name);

        if (!dealerNames.length) return "";

        const uniqueDealerNames = [...new Set(dealerNames)];

        return uniqueDealerNames.length === 1 ? uniqueDealerNames[0] : "Multiple Dealers";
    };

    const handleBudgetYearChange = (e) => {
        const value = parseInt(e.target.value, 10);
        const newSort = filter.sort === -1 ? 1 : filter.sort;
        setSelectedBudgetYear(value);
        removeHighlighter();
        setFilter(prev => ({ ...prev, searchBudgetYear: value, sort: newSort }));
    };

    const handleUpdateQuoteBudgetYear = (quoteId) => async (e) => {
        const value = parseInt(e.target.value, 10);
        try {
            await updateQuoteBudgetYear(quoteId, value);
            const response = await getDistrictQuotesV2(districtId, filter);
            setQuotes(response.data.data);
        } catch (error) {
            console.error("Failed to update budget year:", error);
        }
    };


    const thumbRef = useRef(null);
    const [thumbWidth, setThumbWidth] = useState(0);
    const [showScrollbar, setShowScrollbar] = useState(false);


    // Update thumb on scroll and resize
    const updateThumb = () => {
        const content = tableStickyRef.current;
        if (!content) return;

        const ratio = content.clientWidth / content.scrollWidth;
        const newThumbWidth = content.clientWidth * ratio;
        setThumbWidth(newThumbWidth);

        // Show or hide scrollbar
        setShowScrollbar(content.scrollWidth > content.clientWidth);
    };


    const handleScroll = () => {
        const content = tableStickyRef.current;
        const thumb = thumbRef.current;

        if (!content || !thumb) return;

        const scrollWidth = content.scrollWidth;
        const clientWidth = content.clientWidth;
        const scrollLeft = content.scrollLeft;

        const maxScrollLeft = scrollWidth - clientWidth;
        const maxThumbLeft = clientWidth - thumb.offsetWidth;

        // Avoid division by zero
        const scrollRatio = maxScrollLeft === 0 ? 0 : scrollLeft / maxScrollLeft;

        const thumbLeft = scrollRatio * maxThumbLeft;

        thumb.style.left = `${thumbLeft}px`;
    };



    useEffect(() => {
        const content = tableStickyRef.current;
        if (!content) return;

        const updateOnReady = () => {
            updateThumb();
        };

        // Run once after paint
        requestAnimationFrame(updateOnReady);

        // Fallback in case layout is delayed
        const delayUpdate = setTimeout(updateOnReady, 100);

        // Resize event
        window.addEventListener('resize', updateOnReady);

        // Observe DOM changes inside the scrollable element
        const observer = new MutationObserver(updateOnReady);
        observer.observe(content, { childList: true, subtree: true });

        // Scroll event
        content.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('resize', updateOnReady);
            content.removeEventListener('scroll', handleScroll);
            clearTimeout(delayUpdate);
            observer.disconnect();
        };
    }, []);



    // Add mouse + touch drag functionality
    useEffect(() => {
        const thumb = thumbRef.current;
        const content = tableStickyRef.current;

        let startX = 0;
        let startScrollLeft = 0;

        const onStart = (e) => {
            e.preventDefault();
            startX = e.type === 'mousedown' ? e.clientX : e.touches[0].clientX;
            startScrollLeft = content.scrollLeft;

            document.addEventListener('mousemove', onMove);
            document.addEventListener('mouseup', onEnd);
            document.addEventListener('touchmove', onMove, { passive: false });
            document.addEventListener('touchend', onEnd);
        };

        const onMove = (e) => {
            const clientX = e.type === 'mousemove' ? e.clientX : e.touches[0].clientX;
            const deltaX = clientX - startX;
            const scrollRatio = (content.scrollWidth - content.clientWidth) / (content.clientWidth - thumbWidth);
            content.scrollLeft = startScrollLeft + deltaX * scrollRatio;
        };

        const onEnd = () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onEnd);
            document.removeEventListener('touchmove', onMove);
            document.removeEventListener('touchend', onEnd);
        };

        if (thumb) {
            thumb.addEventListener('mousedown', onStart);
            thumb.addEventListener('touchstart', onStart, { passive: false });
        }

        return () => {
            if (thumb) {
                thumb.removeEventListener('mousedown', onStart);
                thumb.removeEventListener('touchstart', onStart);
            }
        };
    }, [thumbWidth]);


    const statuses = [
        { value: -1, text: 'All Status' },
        { value: 0, text: 'Pending District Approval' },
        { value: 1, text: 'Reviewing' },
        { value: 2, text: 'Send to Vendor for Quote' },
        { value: 3, text: 'Final Quote Provided' },
        { value: 4, text: 'PO Issued' }
    ];

    const handleStatusClick = (e, quote, index) => {
        e.stopPropagation();
        handleStatusOnEnter(quote, index);
    }

    const handleStatusOnEnter = (quote, index) => {
        const subQuoteStatus = quote?.subQuotes
            ?.map(sq => sq.statusText)
            ?.filter(Boolean) || [];

        const uniqueSubQuoteStatus = [...new Set(subQuoteStatus)];

        const multipleFromSubQuotes = uniqueSubQuoteStatus.length > 0;

        if (multipleFromSubQuotes) {
            setSelectedStatusRowIndex(index);
        }
    }

    const getBudgetYearDisplay = (quote, budgetYearsList) => {
        if (!quote.subQuotes?.length) return null;

        const uniqueBudgetYears = [...new Set(
            quote.subQuotes.map(sub => sub.budgetId)
        )];

        if (uniqueBudgetYears.length === 1) {
            const budgetYear = budgetYearsList.find(
                b => b.baseId === uniqueBudgetYears[0]
            );
            return <span>{budgetYear?.budgetYear || ''}</span>;
        }
        return "Multiple";
    };
   
    return (
        <div className="myaccount-table-center">
            <Banner />
            {isLoading && (
                <PageLoadingSpinner show={true}></PageLoadingSpinner>
            )}
            <div className="product-header-wrap">
                <div>
                    <div className="product-breadcrumbs-wrap">
                        <p>
                            <a className="breadcrumb" href="/home">Home</a><span>&nbsp;/&nbsp;</span>
                            <span>My Quotes</span>
                        </p>
                    </div>
                </div>
                <div className="product-main-title-wrap">
                    <h1 className="product-main-title mb-0">My Quotes</h1>
                    <div className='my-account-filter'>
                        <div className='form-group input-form-group'>
                            <label className="cart-side-label">Search by Quote#</label>
                            <div className="cart-side-input search-quote-input">
                                <input
                                    type="text"
                                    id="SearchbyQuote"
                                    name="SearchbyQuote"
                                    value={searchQuote}
                                    aria-label="Search by Quote"
                                    onBlur={handleQuoteNumberChange}
                                    placeholder="Enter last 4 digits"
                                    onChange={handleInputChange}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleQuoteNumberChange(e);
                                        }
                                    }}
                                />
                                <span className="search-quote-button-icon" onClick={() => {
                                    const newSort = filter.sort === -1 ? 1 : filter.sort;
                                    setFilter((prev) => ({
                                        ...prev,
                                        searchQuoteNumber: searchQuote,
                                        sort: newSort
                                    }));
                                }}><span className="material-symbols-rounded">arrow_right_alt</span></span>
                            </div>
                        </div>
                        <div className='form-group filter-btn'>
                            <button type='button' onClick={() => setIsModalOpen(true)}>
                                <span>Filter (2) </span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <mask id="mask0_12787_1386" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                                        <rect width="16" height="16" fill="#757575" />
                                    </mask>
                                    <g mask="url(#mask0_12787_1386)">
                                        <path d="M2.66675 12.5001C2.5223 12.5001 2.40297 12.453 2.30875 12.3587C2.21408 12.2641 2.16675 12.1445 2.16675 12.0001C2.16675 11.8556 2.21408 11.7361 2.30875 11.6414C2.40297 11.5472 2.5223 11.5001 2.66675 11.5001H5.33341C5.47786 11.5001 5.59741 11.5472 5.69208 11.6414C5.7863 11.7361 5.83341 11.8556 5.83341 12.0001C5.83341 12.1445 5.7863 12.2641 5.69208 12.3587C5.59741 12.453 5.47786 12.5001 5.33341 12.5001H2.66675ZM2.66675 4.50008C2.5223 4.50008 2.40297 4.45275 2.30875 4.35808C2.21408 4.26386 2.16675 4.14453 2.16675 4.00008C2.16675 3.85564 2.21408 3.7363 2.30875 3.64208C2.40297 3.54741 2.5223 3.50008 2.66675 3.50008H8.00008C8.14453 3.50008 8.26408 3.54741 8.35875 3.64208C8.45297 3.7363 8.50008 3.85564 8.50008 4.00008C8.50008 4.14453 8.45297 4.26386 8.35875 4.35808C8.26408 4.45275 8.14453 4.50008 8.00008 4.50008H2.66675ZM8.00008 13.8334C7.85564 13.8334 7.7363 13.7863 7.64208 13.6921C7.54741 13.5974 7.50008 13.4779 7.50008 13.3334V10.6667C7.50008 10.5223 7.54741 10.4027 7.64208 10.3081C7.7363 10.2139 7.85564 10.1667 8.00008 10.1667C8.14453 10.1667 8.26408 10.2139 8.35875 10.3081C8.45297 10.4027 8.50008 10.5223 8.50008 10.6667V11.5001H13.3334C13.4779 11.5001 13.5974 11.5472 13.6921 11.6414C13.7863 11.7361 13.8334 11.8556 13.8334 12.0001C13.8334 12.1445 13.7863 12.2641 13.6921 12.3587C13.5974 12.453 13.4779 12.5001 13.3334 12.5001H8.50008V13.3334C8.50008 13.4779 8.45297 13.5974 8.35875 13.6921C8.26408 13.7863 8.14453 13.8334 8.00008 13.8334ZM5.33341 9.83341C5.18897 9.83341 5.06964 9.78608 4.97541 9.69141C4.88075 9.59719 4.83341 9.47786 4.83341 9.33341V8.50008H2.66675C2.5223 8.50008 2.40297 8.45275 2.30875 8.35808C2.21408 8.26386 2.16675 8.14453 2.16675 8.00008C2.16675 7.85564 2.21408 7.73608 2.30875 7.64141C2.40297 7.54719 2.5223 7.50008 2.66675 7.50008H4.83341V6.66675C4.83341 6.5223 4.88075 6.40275 4.97541 6.30808C5.06964 6.21386 5.18897 6.16675 5.33341 6.16675C5.47786 6.16675 5.59741 6.21386 5.69208 6.30808C5.7863 6.40275 5.83341 6.5223 5.83341 6.66675V9.33341C5.83341 9.47786 5.7863 9.59719 5.69208 9.69141C5.59741 9.78608 5.47786 9.83341 5.33341 9.83341ZM8.00008 8.50008C7.85564 8.50008 7.7363 8.45275 7.64208 8.35808C7.54741 8.26386 7.50008 8.14453 7.50008 8.00008C7.50008 7.85564 7.54741 7.73608 7.64208 7.64141C7.7363 7.54719 7.85564 7.50008 8.00008 7.50008H13.3334C13.4779 7.50008 13.5974 7.54719 13.6921 7.64141C13.7863 7.73608 13.8334 7.85564 13.8334 8.00008C13.8334 8.14453 13.7863 8.26386 13.6921 8.35808C13.5974 8.45275 13.4779 8.50008 13.3334 8.50008H8.00008ZM10.6667 5.83341C10.5223 5.83341 10.403 5.78608 10.3087 5.69141C10.2141 5.59719 10.1667 5.47786 10.1667 5.33341V2.66675C10.1667 2.5223 10.2141 2.40275 10.3087 2.30808C10.403 2.21386 10.5223 2.16675 10.6667 2.16675C10.8112 2.16675 10.9307 2.21386 11.0254 2.30808C11.1196 2.40275 11.1667 2.5223 11.1667 2.66675V3.50008H13.3334C13.4779 3.50008 13.5974 3.54741 13.6921 3.64208C13.7863 3.7363 13.8334 3.85564 13.8334 4.00008C13.8334 4.14453 13.7863 4.26386 13.6921 4.35808C13.5974 4.45275 13.4779 4.50008 13.3334 4.50008H11.1667V5.33341C11.1667 5.47786 11.1196 5.59719 11.0254 5.69141C10.9307 5.78608 10.8112 5.83341 10.6667 5.83341Z" fill="#757575" />
                                    </g>
                                </svg>
                            </button>
                        </div>
                        <div className={`filter-modal ${isModalOpen ? 'filter-modal-open' : ''}`}>
                            <div className='filter-modal-content' ref={modalRef}>
                                <div className='filter-modal-header'>
                                    <h6>Filter</h6>
                                    <span className='filter-close-btn' onClick={() => setIsModalOpen(false)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                            <mask id="mask0_12787_1860" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
                                                <rect width="28" height="28" fill="#D9D9D9" />
                                            </mask>
                                            <g mask="url(#mask0_12787_1860)">
                                                <path d="M14.0006 15.225L8.07979 21.1458C7.92423 21.3014 7.72512 21.3838 7.48245 21.3932C7.23901 21.4033 7.02979 21.3208 6.85479 21.1458C6.67979 20.9708 6.59229 20.7667 6.59229 20.5333C6.59229 20.3 6.67979 20.0958 6.85479 19.9208L12.7756 14L6.85479 8.07917C6.69923 7.92362 6.61679 7.72412 6.60745 7.48067C6.59734 7.23801 6.67979 7.02917 6.85479 6.85417C7.02979 6.67917 7.23395 6.59167 7.46729 6.59167C7.70062 6.59167 7.90479 6.67917 8.07979 6.85417L14.0006 12.775L19.9215 6.85417C20.077 6.69862 20.2765 6.61579 20.52 6.60567C20.7626 6.59634 20.9715 6.67917 21.1465 6.85417C21.3215 7.02917 21.409 7.23334 21.409 7.46667C21.409 7.70001 21.3215 7.90417 21.1465 8.07917L15.2256 14L21.1465 19.9208C21.302 20.0764 21.3845 20.2755 21.3938 20.5182C21.4039 20.7616 21.3215 20.9708 21.1465 21.1458C20.9715 21.3208 20.7673 21.4083 20.534 21.4083C20.3006 21.4083 20.0965 21.3208 19.9215 21.1458L14.0006 15.225Z" fill="#757575" />
                                            </g>
                                        </svg>
                                    </span>
                                </div>
                                <div className='filter-modal-body'>
                                    <div className='form-group'>
                                        <label className="cart-side-label">Budget Year</label>
                                        <div className='cart-side-input cart-select-wrapper arrow-button'>
                                            <select name="budgetyear" className='cart-grid-select cart-select-arrow' id="budgetyear"
                                                value={selectedBudgetYear}
                                                onChange={handleBudgetYearChange}>
                                                <option value="0">All Budgets</option>
                                                {budgetYearsList.map((budget) => (
                                                    <option key={budget.baseId} value={budget.baseId}>{budget.budgetYear}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='form-group'>
                                        <label className="cart-side-label">Manufacturer</label>
                                        <div className='cart-side-input cart-select-wrapper arrow-button'>
                                            <select
                                                name="Manufacturer"
                                                id="Manufacturer"
                                                value={selectedManufacturer}
                                                onChange={handleManufacturerChange}
                                                className='cart-grid-select cart-select-arrow'
                                            >
                                                <option value="0">All Manufacturers</option>
                                                {manufacturers.map((mfr) => (
                                                    <option key={mfr.id} value={mfr.id}>{mfr.name}</option>
                                                ))}
                                            </select>

                                        </div>
                                    </div>
                                    <div className='form-group'>
                                        <label className="cart-side-label">School </label>
                                        <div className='cart-side-input cart-select-wrapper arrow-button'>
                                            <select
                                                name="School"
                                                id="School"
                                                value={selectedSchool}
                                                onChange={handleSchoolChange}
                                                className='cart-grid-select cart-select-arrow'
                                            >
                                                <option value="0">All Schools</option>
                                                {schools.map((school) => (
                                                    <option key={school.baseId} value={school.baseId}>{school.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='form-group dealer-form-group'>
                                        <label className="cart-side-label">Dealer</label>
                                        <div className='cart-side-input cart-select-wrapper arrow-button'>
                                            <select
                                                name="Dealer"
                                                id="Dealer"
                                                value={selectedDealer}
                                                onChange={handleDealerChange}
                                                className='cart-grid-select cart-select-arrow'
                                            >
                                                <option value="">All Dealers</option>
                                                {dealerList.map((dealer) => (
                                                    <option key={dealer.siteUserId} value={dealer.siteUserId}>{dealer.siteUsers?.fullName}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='form-group dealer-form-group'>
                                        <label className="cart-side-label">Status</label>
                                        <div className='cart-side-input cart-select-wrapper arrow-button'>
                                            <select
                                                name="Dealer"
                                                id="Dealer"
                                                value={filter.status}
                                                onChange={handleChangeStatus}
                                                className='cart-grid-select cart-select-arrow'
                                            >
                                                {statuses.map((status) => (
                                                    <option key={'status_' + status.value} value={status.value}>{status.text}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='filter-modal-footer'>
                                    <button type='button' className='clear-filter-btn' onClick={handleClearFilters}>Clear Filters</button>
                                    <button type='button' className='apply-filter-button' onClick={handleApplyFilters}>Apply</button>
                                </div>
                            </div>
                        </div>
                        <a className="product-main-logout-button" href="/account/logout">Logout</a>
                    </div>
                </div>
                <div className='Subtotaling-price'>
                    <label>Quote Total</label>
                    <p className='mb-0'>{quotes?.quotesTotal && formatUSD(quotes?.quotesTotal)}</p>
                </div>
            </div>

            <div className={`admin-table-wrap ${isScrolled ? 'scrolled' : ''}`} ref={tableStickyRef}>
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th scope="col" onClick={() => setFilter({ ...filter, sort: filter.sort == 0 ? 1 : 0 })} className={filter.sort == 0 ? 'admin-table-name-cell sortable sorted-dn account-quote sticky' : (filter.sort == 1 ? 'admin-table-name-cell sortable sorted-up sticky' : 'admin-table-name-cell sortable sticky')}>Quote</th>
                            <th scope="col" className="admin-table-name-cell">Budget Year</th>
                            <th scope="col" onClick={() => setFilter({ ...filter, sort: filter.sort == 4 ? 5 : 4 })} className={filter.sort == 4 ? 'admin-table-name-cell sortable sorted-dn account-submit-date' : (filter.sort == 5 ? 'admin-table-name-cell sortable sorted-up account-submit-date' : 'admin-table-name-cell sortable account-submit-date')}>Submit Date</th>
                            <th scope="col" className="admin-table-name-cell account-in-items text-end">Items</th>
                            <th scope="col" className="admin-table-name-cell text-end">Total</th>
                            <th scope="col" className="admin-table-name-cell min-w">School</th>
                            <th scope="col" className="admin-table-name-cell account-in-dealer">Dealer</th>
                            <th scope="col" className="admin-table-name-cell ">Manufacturer</th>
                            <th scope="col" onClick={() => setFilter({ ...filter, sort: filter.sort == 6 ? 7 : 6 })} className={filter.sort == 6 ? 'admin-table-name-cell sortable sorted-dn' : (filter.sort == 7 ? 'admin-table-name-cell sortable sorted-up' : 'admin-table-name-cell sortable min-w-status')}>Status</th>
                            <td scope="col" className="admin-table-action-cell">&nbsp;</td>
                        </tr>
                    </thead>
                    <tbody>
                        {quotes?.results?.length > 0 ? (
                            quotes.results.map((quote, index) => {
                                const isExpanded = quote.id === expandedQuoteId;

                                const isBudgetFilterActive = filter.searchBudgetYear > 0;

                                if (isBudgetFilterActive && quote.budgetId !== filter.searchBudgetYear) {
                                    quote.budgetId = filter.searchBudgetYear;

                                    const matchedBudget = budgetYearsList?.find(x => x.baseId === filter.searchBudgetYear);
                                    if (matchedBudget?.budgetYear) {
                                        quote.budgetYearName = matchedBudget.budgetYear;
                                    }
                                }

                                return (
                                    <React.Fragment key={index}>
                                        <tr
                                            onClick={() => {
                                                setExpandedQuoteId(isExpanded ? null : quote.id);
                                                if (quoteHighlighterId > 0 && quoteHighlighterId != quote.id) {
                                                    dispatch(setQuoteHighlighterId(0));
                                                }
                                            }}
                                            className={`clickable-row ${(quote.status === 0 || quote.status === 3) && quote.subQuotes?.length === 0 ? "edit-tr" : ""} ${isExpanded ? "expanded" : ""} ${quoteHighlighterId == quote.id ? "highlight" : ""}`}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <td className="admin-table-name-cell sticky">
                                                {quote.label ?? 'My Project'} <br />({quote.districtId}-{("000" + quote.id).slice(-4)})
                                            </td>
                                            <td className="admin-table-name-cell">
                                                {quote.subQuotes?.length > 0 ? (
                                                    getBudgetYearDisplay(quote, budgetYearsList)
                                                     ) : quotes?.isAdminApproval ? (
                                                    <div className='cart-select-wrapper arrow-button'>
                                                        <select name="budget-year" id={`budget-year-${quote.id}`} value={quote.budgetId || 1} onChange={handleUpdateQuoteBudgetYear(quote.id)} className='cart-grid-select cart-select-arrow' onClick={(e) => e.stopPropagation()} >
                                                            {budgetYearsList.map((budget) => (
                                                                <option key={budget.baseId} value={budget.baseId}>{budget.budgetYear}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                ) : (
                                                    <span>{quote.budgetYearName}</span>
                                                )}
                                            </td>
                                            <td className="admin-table-name-cell space-nowrap">{formatDateTimeForUserTimeZone(quote.created)?.split(' @ ')[0] || ''}</td>
                                            <td className="admin-table-name-cell text-end">{quote.totalSubQuotesQuantity}</td>
                                            <td className="admin-table-name-cell text-end">{formatUSD(quote.totalSubQuotesPrice)}</td>
                                            <td className="admin-table-name-cell">{quote.schoolName}</td>
                                            <td
                                                className="admin-table-name-cell dealer-hover-li"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (popupContext.show && popupContext.type === 'main' && popupContext.rowIndex === index) {
                                                        return;
                                                    }

                                                    const dealerIds = quote.subQuotes?.length > 0
                                                        ? [...new Set(quote.subQuotes.map(sq => sq.dealerId).filter(id => id))]
                                                        : quote.dealerId ? [quote.dealerId] : [];

                                                    if (dealerIds.length > 0) {
                                                        fetchDealersDetails(dealerIds, index);
                                                    }
                                                }}
                                                onMouseEnter={(e) => {
                                                    setCursorPosition({ x: e.clientX, y: e.clientY });

                                                    if (popupContext.show && popupContext.type === 'main' && popupContext.rowIndex === index) {
                                                        return;
                                                    }

                                                    const dealerIds = quote.subQuotes?.length > 0
                                                        ? [...new Set(quote.subQuotes.map(sq => sq.dealerId).filter(id => id))]
                                                        : quote.dealerId ? [quote.dealerId] : [];

                                                    if (dealerIds.length > 0) {
                                                        fetchDealersDetails(dealerIds, index);
                                                    }
                                                }}
                                                onMouseLeave={() => closePopup()}
                                            >

                                                {quote.subQuotes?.length > 0 ? (
                                                    checkSameDealers(quote.subQuotes) ? (
                                                        <>
                                                            {quote.subQuotes[0]?.dealerName}
                                                            {popupContext.show && popupContext.type === 'main' && popupContext.rowIndex === index && (
                                                                <DealerDetails
                                                                    dealersDetails={dealersDetails}
                                                                    setDealersDetails={setDealersDetails}
                                                                    showPopup={popupContext.show}
                                                                    cursorPosition={cursorPosition}
                                                                    setShowPopup={(show) => setPopupContext(prev => ({
                                                                        ...prev,
                                                                        show
                                                                    }))}
                                                                />
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {getDealerDisplayText(quote.subQuotes)}
                                                            {popupContext.show && popupContext.type === 'main' && popupContext.rowIndex === index && (
                                                                <DealerDetails
                                                                    setDealersDetails={setDealersDetails}
                                                                    dealersDetails={dealersDetails}
                                                                    showPopup={popupContext.show}
                                                                    cursorPosition={cursorPosition}
                                                                    setShowPopup={(show) => setPopupContext(prev => ({
                                                                        ...prev,
                                                                        show
                                                                    }))}
                                                                />
                                                            )}
                                                        </>
                                                    )
                                                ) : (
                                                    <>
                                                        {quote.dealerName}
                                                        {popupContext.show && popupContext.type === 'main' && popupContext.rowIndex === index && (
                                                            <DealerDetails
                                                                setDealersDetails={setDealersDetails}
                                                                dealersDetails={dealersDetails}
                                                                showPopup={popupContext.show}
                                                                cursorPosition={cursorPosition}
                                                                setShowPopup={(show) => setPopupContext(prev => ({
                                                                    ...prev,
                                                                    show
                                                                }))}
                                                            />
                                                        )}
                                                    </>
                                                )}
                                            </td>

                                            <td
                                                className="admin-table-name-cell dealer-hover-li"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    const subQuoteManufacturers = quote?.subQuotes
                                                        ?.map(sq => sq.manufactureName)
                                                        ?.filter(Boolean) || [];

                                                    const uniqueSubQuoteManufacturers = [...new Set(subQuoteManufacturers)];

                                                    const multipleFromSubQuotes = uniqueSubQuoteManufacturers.length > 0;
                                                    const multipleFromMultipal = (quote?.multipalManufacturers ?? '').includes(',');

                                                    if (multipleFromSubQuotes || multipleFromMultipal) {
                                                        setSelectedManufacturerRowIndex(index);
                                                    }
                                                }}
                                                onMouseEnter={(e) => {
                                                    setCursorPosition({ x: e.clientX, y: e.clientY });

                                                    const subQuoteManufacturers = quote?.subQuotes
                                                        ?.map(sq => sq.manufactureName)
                                                        ?.filter(Boolean) || [];

                                                    const uniqueSubQuoteManufacturers = [...new Set(subQuoteManufacturers)];

                                                    const multipleFromSubQuotes = uniqueSubQuoteManufacturers.length > 0;
                                                    const multipleFromMultipal = (quote?.multipalManufacturers ?? '').includes(',');

                                                    if (multipleFromSubQuotes || multipleFromMultipal) {
                                                        setSelectedManufacturerRowIndex(index);
                                                    }
                                                }}

                                                onMouseLeave={() => {
                                                    setSelectedManufacturerRowIndex(null);
                                                }}
                                            >
                                                {quote?.subQuotes?.length > 1 ? (
                                                    <>
                                                        Multiple Manufacturers

                                                        {selectedManufacturerRowIndex === index && (
                                                            <div className="tr-hover-alert" style={{ display: 'flex', position: 'fixed', top: cursorPosition.y + 10 + 'px', left: cursorPosition.x + 10 + 'px',}} >
                                                                <div className='tr-card'>
                                                                    <a
                                                                        className="close-icon"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setSelectedManufacturerRowIndex(null);
                                                                        }}
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                                            <mask id="mask0_12046_372" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                                                                                <rect width="18" height="18" fill="#D9D9D9" />
                                                                            </mask>
                                                                            <g mask="url(#mask0_12046_372)">
                                                                                <path d="M9.0001 10.0501L5.3251 13.7251C5.1876 13.8626 5.0126 13.9313 4.8001 13.9313C4.5876 13.9313 4.4126 13.8626 4.2751 13.7251C4.1376 13.5876 4.06885 13.4126 4.06885 13.2001C4.06885 12.9876 4.1376 12.8126 4.2751 12.6751L7.9501 9.0001L4.2751 5.3251C4.1376 5.1876 4.06885 5.0126 4.06885 4.8001C4.06885 4.5876 4.1376 4.4126 4.2751 4.2751C4.4126 4.1376 4.5876 4.06885 4.8001 4.06885C5.0126 4.06885 5.1876 4.1376 5.3251 4.2751L9.0001 7.9501L12.6751 4.2751C12.8126 4.1376 12.9876 4.06885 13.2001 4.06885C13.4126 4.06885 13.5876 4.1376 13.7251 4.2751C13.8626 4.4126 13.9313 4.5876 13.9313 4.8001C13.9313 5.0126 13.8626 5.1876 13.7251 5.3251L10.0501 9.0001L13.7251 12.6751C13.8626 12.8126 13.9313 12.9876 13.9313 13.2001C13.9313 13.4126 13.8626 13.5876 13.7251 13.7251C13.5876 13.8626 13.4126 13.9313 13.2001 13.9313C12.9876 13.9313 12.8126 13.8626 12.6751 13.7251L9.0001 10.0501Z" fill="#1C1B1F" />
                                                                            </g>
                                                                        </svg>
                                                                    </a>
                                                                    <p className="mb-0">
                                                                        {quote?.subQuotes
                                                                            ?.map(x => x.manufactureName)
                                                                            ?.filter((value, index, self) => value && self.indexOf(value) === index)
                                                                            ?.join(', ') || quote?.multipalManufacturers}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : quote?.subQuotes?.length === 1 ? (
                                                    quote.subQuotes[0]?.manufactureName
                                                ) : (
                                                    quote?.manufactureName
                                                )}
                                            </td>
                                            <td className="admin-table-name-cell"
                                                onClick={(e) => handleStatusClick(e, quote, index)}
                                                onMouseEnter={(e) => {
                                                        setCursorPosition({ x: e.clientX, y: e.clientY });
                                                        handleStatusOnEnter(quote, index);
                                                }}
                                                onMouseLeave={() => {
                                                    setSelectedStatusRowIndex(null);
                                                }}
                                            >
                                                {quote?.subQuotes?.length > 1 ? (
                                                    <>
                                                        {quote?.subQuotes
                                                            ?.map(x => x.statusText)
                                                            ?.filter((value, index, self) => value && self.indexOf(value) === index).length === 1 ?
                                                            quote?.subQuotes
                                                                ?.map(x => x.statusText)
                                                                ?.filter((value, index, self) => value && self.indexOf(value) === index)
                                                                ?.join(', ') :
                                                            'Multiple Status'
                                                        }
                                                        {selectedStatusRowIndex === index && (
                                                            <div className="tr-hover-alert" style={{ display: 'block', minWidth: '21em', position: 'fixed', top: cursorPosition.y + 10 + 'px', left: cursorPosition.x + 10 + 'px', }} >
                                                                <div className='tr-card'>
                                                                    <a
                                                                        className="close-icon"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setSelectedStatusRowIndex(null);
                                                                        }}
                                                                    >
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                                            <mask id="mask0_12046_372" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                                                                                <rect width="18" height="18" fill="#D9D9D9" />
                                                                            </mask>
                                                                            <g mask="url(#mask0_12046_372)">
                                                                                <path d="M9.0001 10.0501L5.3251 13.7251C5.1876 13.8626 5.0126 13.9313 4.8001 13.9313C4.5876 13.9313 4.4126 13.8626 4.2751 13.7251C4.1376 13.5876 4.06885 13.4126 4.06885 13.2001C4.06885 12.9876 4.1376 12.8126 4.2751 12.6751L7.9501 9.0001L4.2751 5.3251C4.1376 5.1876 4.06885 5.0126 4.06885 4.8001C4.06885 4.5876 4.1376 4.4126 4.2751 4.2751C4.4126 4.1376 4.5876 4.06885 4.8001 4.06885C5.0126 4.06885 5.1876 4.1376 5.3251 4.2751L9.0001 7.9501L12.6751 4.2751C12.8126 4.1376 12.9876 4.06885 13.2001 4.06885C13.4126 4.06885 13.5876 4.1376 13.7251 4.2751C13.8626 4.4126 13.9313 4.5876 13.9313 4.8001C13.9313 5.0126 13.8626 5.1876 13.7251 5.3251L10.0501 9.0001L13.7251 12.6751C13.8626 12.8126 13.9313 12.9876 13.9313 13.2001C13.9313 13.4126 13.8626 13.5876 13.7251 13.7251C13.5876 13.8626 13.4126 13.9313 13.2001 13.9313C12.9876 13.9313 12.8126 13.8626 12.6751 13.7251L9.0001 10.0501Z" fill="#1C1B1F" />
                                                                            </g>
                                                                        </svg>
                                                                    </a>
                                                                    <p className="mb-0">
                                                                        {quote?.subQuotes
                                                                            ?.map((x, subIndex) => (
                                                                                <span key={x.id} style={{ display: 'block' }}>{quote.districtId}-{("000" + quote.id).slice(-4)}.{("0" + (subIndex + 1)).slice(-2)}  - {x.statusText}</span>
                                                                            ))}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        )}

                                                    </>
                                                ) : quote?.subQuotes?.length === 1 ? (
                                                    quote.subQuotes[0]?.statusText
                                                ) : (
                                                    quote?.statusText
                                                )}
                                            </td>
                                            <td className="admin-table-name-cell nowrap">
                                                <div className='action-td'>
                                                    {isEndUser && (
                                                        <Link className="default-cta" to={`/my-quote/${quote.id}`}>View</Link>
                                                    )}

                                                    {!isEndUser && (
                                                        <Link
                                                            className={`default-cta ${!quote.isView && quote.status === 0 && quote.subQuotes?.length === 0 ? "editable" : ""}`}
                                                            to={`/my-quote/${quote.id}`}
                                                        >
                                                            {quote.subQuotes?.length > 0 ? (
                                                                "View"
                                                            ) : quote.status === 0 && !quote.isView ? (
                                                                <>
                                                                    Edit{" "}
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                        <mask id="mask0" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                                                                            <rect width="16" height="16" fill="#B50000" />
                                                                        </mask>
                                                                        <g mask="url(#mask0)">
                                                                            <path
                                                                                d="M8.00016 11.3333C8.18905 11.3333 8.34738 11.2694 8.47516 11.1417C8.60294 11.0139 8.66683 10.8555 8.66683 10.6667C8.66683 10.4778 8.60294 10.3194 8.47516 10.1917C8.34738 10.0639 8.18905 9.99999 8.00016 9.99999C7.81127 9.99999 7.65294 10.0639 7.52516 10.1917C7.39738 10.3194 7.3335 10.4778 7.3335 10.6667C7.3335 10.8555 7.39738 11.0139 7.52516 11.1417C7.65294 11.2694 7.81127 11.3333 8.00016 11.3333ZM8.00016 8.66666C8.18905 8.66666 8.34738 8.60277 8.47516 8.47499C8.60294 8.34722 8.66683 8.18888 8.66683 7.99999V5.33333C8.66683 5.14444 8.60294 4.98611 8.47516 4.85833C8.34738 4.73055 8.18905 4.66666 8.00016 4.66666C7.81127 4.66666 7.65294 4.73055 7.52516 4.85833C7.39738 4.98611 7.3335 5.14444 7.3335 5.33333V7.99999C7.3335 8.18888 7.39738 8.34722 7.52516 8.47499C7.65294 8.60277 7.81127 8.66666 8.00016 8.66666ZM8.00016 14.6667C7.07794 14.6667 6.21127 14.4917 5.40016 14.1417C4.58905 13.7917 3.8835 13.3167 3.2835 12.7167C2.6835 12.1167 2.2085 11.4111 1.8585 10.6C1.5085 9.78888 1.3335 8.92222 1.3335 7.99999C1.3335 7.07777 1.5085 6.21111 1.8585 5.39999C2.2085 4.58888 2.6835 3.88333 3.2835 3.28333C3.8835 2.68333 4.58905 2.20833 5.40016 1.85833C6.21127 1.50833 7.07794 1.33333 8.00016 1.33333C8.92238 1.33333 9.78905 1.50833 10.6002 1.85833C11.4113 2.20833 12.1168 2.68333 12.7168 3.28333C13.3168 3.88333 13.7918 4.58888 14.1418 5.39999C14.4918 6.21111 14.6668 7.07777 14.6668 7.99999C14.6668 8.92222 14.4918 9.78888 14.1418 10.6C13.7918 11.4111 13.3168 12.1167 12.7168 12.7167C12.1168 13.3167 11.4113 13.7917 10.6002 14.1417C9.78905 14.4917 8.92238 14.6667 8.00016 14.6667Z"
                                                                                fill="#B50000"
                                                                            />
                                                                        </g>
                                                                    </svg>
                                                                </>
                                                            ) : (
                                                                "View"
                                                            )}
                                                        </Link>
                                                    )}


                                                    {(quote.subQuotes?.length > 0 || quote.status !== 0) && (
                                                        <span className='expand-arrow'>
                                                            {quote.status === 0 && quote.subQuotes?.length === 0 ?
                                                                <>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                        <mask id="mask2" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                                            <rect x="24" y="24" width="24" height="24" transform="rotate(-180 24 24)" fill="#B50000" fillOpacity="0.65" />
                                                                        </mask>
                                                                        <g mask="url(#mask2)">
                                                                            <path d="M17.1264 9.48843C17.2713 9.6333 17.3438 9.80893 17.3438 10.0153C17.3438 10.2218 17.2713 10.3974 17.1264 10.5423L12.6322 15.0365C12.5386 15.1301 12.4399 15.1961 12.3361 15.2346C12.2322 15.273 12.12 15.2922 11.9995 15.2922C11.879 15.2922 11.7668 15.273 11.663 15.2346C11.5592 15.1961 11.4604 15.1301 11.3669 15.0365L6.84763 10.5173C6.70916 10.3788 6.63993 10.2115 6.63993 10.0153C6.63993 9.81918 6.7175 9.64355 6.87263 9.48843C7.0175 9.34357 7.19313 9.27113 7.39953 9.27113C7.60593 9.27113 7.78156 9.34357 7.92643 9.48843L11.9995 13.5615L16.0976 9.46343C16.2361 9.32497 16.4034 9.25573 16.5995 9.25573C16.7957 9.25573 16.9713 9.3333 17.1264 9.48843Z" fill="#B50000" fillOpacity="0.65" />
                                                                        </g>
                                                                    </svg>
                                                                </>
                                                                :
                                                                <>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                        <mask id="mask1" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                                            <rect x="24" y="24" width="24" height="24" transform="rotate(-180 24 24)" fill="#757575" />
                                                                        </mask>
                                                                        <g mask="url(#mask1)">
                                                                            <path d="M17.1264 9.48843C17.2713 9.6333 17.3438 9.80893 17.3438 10.0153C17.3438 10.2218 17.2713 10.3974 17.1264 10.5423L12.6322 15.0365C12.5386 15.1301 12.4399 15.1961 12.3361 15.2346C12.2322 15.273 12.12 15.2922 11.9995 15.2922C11.879 15.2922 11.7668 15.273 11.663 15.2346C11.5592 15.1961 11.4604 15.1301 11.3669 15.0365L6.84763 10.5173C6.70916 10.3788 6.63993 10.2115 6.63993 10.0153C6.63993 9.81918 6.7175 9.64355 6.87263 9.48843C7.0175 9.34357 7.19313 9.27113 7.39953 9.27113C7.60593 9.27113 7.78156 9.34357 7.92643 9.48843L11.9995 13.5615L16.0976 9.46343C16.2361 9.32497 16.4034 9.25573 16.5995 9.25573C16.7957 9.25573 16.9713 9.3333 17.1264 9.48843Z" fill="#757575" />
                                                                        </g>
                                                                    </svg>
                                                                </>
                                                            }
                                                        </span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>

                                        {isExpanded && quote.subQuotes?.map((sub, subIndex) => (
                                            <tr key={`sub-${quote.id}-${sub.id || subIndex}`} className={`subquote-row ${(sub.status === 0 || sub.status === 3) ? "edit-tr" : ""}`}>
                                                <td className="admin-table-name-cell ps-4 sticky">
                                                    ({quote.districtId}-{("000" + quote.id).slice(-4)}.{("0" + (subIndex + 1)).slice(-2)})
                                                </td>
                                                <td className="admin-table-name-cell">
                                                    {quotes?.isAdminApproval ? (
                                                        <div className='cart-select-wrapper arrow-button'>
                                                            <select name="budget-year" id={`budget-year-sub-${sub.id}`} value={sub.budgetId || 1} onChange={handleUpdateQuoteBudgetYear(sub.id)} className='cart-grid-select cart-select-arrow' onClick={(e) => e.stopPropagation()} >
                                                                {budgetYearsList.map((budget) => (
                                                                    <option key={budget.baseId} value={budget.baseId}>{budget.budgetYear}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    ) : (
                                                        <span>{sub.budgetYearName}</span>
                                                    )}
                                                </td>
                                                <td className="admin-table-name-cell">{formatDateTimeForUserTimeZone(quote.created)?.split(' @ ')[0] || ''}</td>
                                                <td className="admin-table-name-cell text-end">{sub.totalQuantity}</td>
                                                <td className="admin-table-name-cell text-end">{formatUSD(sub.totalPrice)}</td>
                                                <td className="admin-table-name-cell">{sub.schoolName}</td>
                                                <td
                                                    className="admin-table-name-cell dealer-hover-li"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        if (popupContext.show && popupContext.type === 'sub' &&
                                                            popupContext.rowIndex === index && popupContext.subRowIndex === subIndex) {
                                                            return;
                                                        }

                                                        if (sub?.dealerId) {
                                                            fetchDealersDetails([sub.dealerId], index, subIndex);
                                                        }
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        setCursorPosition({ x: e.clientX, y: e.clientY });
                                                        if (popupContext.show && popupContext.type === 'sub' &&
                                                            popupContext.rowIndex === index && popupContext.subRowIndex === subIndex) {
                                                            return;
                                                        }

                                                        if (sub?.dealerId) {
                                                            fetchDealersDetails([sub.dealerId], index, subIndex);
                                                        }
                                                    }}
                                                    onMouseLeave={() => closePopup()}
                                                >
                                                    {sub.dealerName}
                                                    {popupContext.show && popupContext.type === 'sub' &&
                                                        popupContext.rowIndex === index && popupContext.subRowIndex === subIndex && (
                                                            <DealerDetails
                                                                dealersDetails={dealersDetails}
                                                                showPopup={popupContext.show}
                                                                setDealersDetails={setDealersDetails}
                                                                cursorPosition={cursorPosition}
                                                                setShowPopup={(show) => setPopupContext(prev => ({
                                                                    ...prev,
                                                                    show
                                                                }))}
                                                            />
                                                        )}
                                                </td>
                                                <td className="admin-table-name-cell">{sub.manufactureName}</td>
                                                <td className="admin-table-name-cell">{sub.statusText}</td>
                                                <td className="admin-table-name-cell nowrap">
                                                    {isEndUser && (
                                                        <Link className="default-cta" to={`/my-quote/${sub.id}`}>View</Link>
                                                    )}
                                                    {!isEndUser && (
                                                        <Link className={`default-cta ${!sub.isView && sub.status === 0 ? "editable" : ""}`} to={`/my-quote/${sub.id}`}>
                                                            {!sub.isView && sub.status === 0 ? <>
                                                                Edit{" "}
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                    <mask id="mask0" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                                                                        <rect width="16" height="16" fill="#B50000" />
                                                                    </mask>
                                                                    <g mask="url(#mask0)">
                                                                        <path
                                                                            d="M8.00016 11.3333C8.18905 11.3333 8.34738 11.2694 8.47516 11.1417C8.60294 11.0139 8.66683 10.8555 8.66683 10.6667C8.66683 10.4778 8.60294 10.3194 8.47516 10.1917C8.34738 10.0639 8.18905 9.99999 8.00016 9.99999C7.81127 9.99999 7.65294 10.0639 7.52516 10.1917C7.39738 10.3194 7.3335 10.4778 7.3335 10.6667C7.3335 10.8555 7.39738 11.0139 7.52516 11.1417C7.65294 11.2694 7.81127 11.3333 8.00016 11.3333ZM8.00016 8.66666C8.18905 8.66666 8.34738 8.60277 8.47516 8.47499C8.60294 8.34722 8.66683 8.18888 8.66683 7.99999V5.33333C8.66683 5.14444 8.60294 4.98611 8.47516 4.85833C8.34738 4.73055 8.18905 4.66666 8.00016 4.66666C7.81127 4.66666 7.65294 4.73055 7.52516 4.85833C7.39738 4.98611 7.3335 5.14444 7.3335 5.33333V7.99999C7.3335 8.18888 7.39738 8.34722 7.52516 8.47499C7.65294 8.60277 7.81127 8.66666 8.00016 8.66666ZM8.00016 14.6667C7.07794 14.6667 6.21127 14.4917 5.40016 14.1417C4.58905 13.7917 3.8835 13.3167 3.2835 12.7167C2.6835 12.1167 2.2085 11.4111 1.8585 10.6C1.5085 9.78888 1.3335 8.92222 1.3335 7.99999C1.3335 7.07777 1.5085 6.21111 1.8585 5.39999C2.2085 4.58888 2.6835 3.88333 3.2835 3.28333C3.8835 2.68333 4.58905 2.20833 5.40016 1.85833C6.21127 1.50833 7.07794 1.33333 8.00016 1.33333C8.92238 1.33333 9.78905 1.50833 10.6002 1.85833C11.4113 2.20833 12.1168 2.68333 12.7168 3.28333C13.3168 3.88333 13.7918 4.58888 14.1418 5.39999C14.4918 6.21111 14.6668 7.07777 14.6668 7.99999C14.6668 8.92222 14.4918 9.78888 14.1418 10.6C13.7918 11.4111 13.3168 12.1167 12.7168 12.7167C12.1168 13.3167 11.4113 13.7917 10.6002 14.1417C9.78905 14.4917 8.92238 14.6667 8.00016 14.6667Z"
                                                                            fill="#B50000"
                                                                        />
                                                                    </g>
                                                                </svg>
                                                            </> : "View"}
                                                        </Link>

                                                    )}
                                                </td>
                                            </tr>
                                        ))}

                                    </React.Fragment>
                                );
                            })
                        ) : (
                            <tr>
                                <td className="admin-table-name-cell" colSpan="10">
                                    No active quotes or requests
                                </td>
                            </tr>
                        )}
                    </tbody>


                </table>
            </div>
            <div className={`custome-scrollbar ${showScrollbar ? 'show' : ''}`}>
                <div
                    className="scrollbar-thumb"
                    ref={thumbRef}
                    style={{ width: `${thumbWidth}px` }}
                ></div>
            </div>
            <div className="my-account-btn">
                <a href="/my-project">Go to My Current Project</a></div>
        </div>
    );
}